import Cashiers from "./cashiers";

export default Cashiers;
